import { jsonApiClient } from '@/httpConfig/config/axios';

// GET /api/v1/suppliers — the club's supplier roster, as a member may read it:
// `{id, name}` per shop, name-sorted. No search, no pagination, no detail, no
// filters (BE→FE brief 2026-09-07-member-contract-round-two, owner decision L-G).
//
// A hand-built JSON:API document, like `clubs/poolshare-total` beside it in
// routes/api.php — NOT a JSON:API resource route. `jsonApiClient` still reads it
// correctly: jsona flattens `data[].attributes.name` onto each row, so the
// deserialized shape is `[{ type: 'suppliers', id: '3', name: 'ترست' }]`.
//
// MEMBERSHIP-GATED, and more narrowly than its structural sibling. An APPROVED
// seller reads it; a user with no membership, one still under review, and a
// Suppliers Club member each get 403 `errors[0].code = 'not-a-member'` — the
// roster is who the club buys from, and a supplier reading it is reading their
// own competitors. An approved member who has not funded her tier yet IS
// allowed: `isActivated()` is deliberately not the bar.
//
// Callers must treat a failure as "no list", never as an error to show her. The
// typed name is the complete path on its own and is the more valuable half of
// the feature — the shop she knows is quite likely one the club has never bought
// from, which is the entire reason for asking.
//
// TWO ADDITIVE READS (BE→FE brief 2026-10-02-suggestion-reward):
//   • `meta.rewardCents` — what naming a shop earns per helped member, in
//     piasters. ABSENT while the reward is off; test for the key.
//   • `?product=<id>` — every row gains `namedByMembers`, how many OTHER members
//     named that shop for that product lately. Without the parameter the key is
//     absent and the rows are exactly `{name}` as before.
export const supplierListService = {
  list: (productId = null) =>
    productId == null
      ? jsonApiClient.get('/suppliers')
      : jsonApiClient.get('/suppliers', { params: { product: productId } }),
};
